import React from 'react';
import PropTypes from 'prop-types';

export const DivContainer = props => {
	const { children, colClass, id, rendered, style } = props;
	if (rendered) {
		return <div className={colClass} style={style} id={id}>{children}</div>;
	} else {
		return null;
	}
};

DivContainer.defaultProps = {
	colClass: 'col-xl-12 col-lg-12 col-md-12 col-sm-12',
	rendered: true,
};

DivContainer.propTypes = {
	colClass: PropTypes.string,
	id: PropTypes.string,
	rendered: PropTypes.bool,
	style: PropTypes.string,	
};

export default DivContainer;
